import React, { useMemo } from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
// import usePermission, { Permission } from '../hooks/usePermission';

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: (v: boolean) => void;
}

const Sidebar = ({ sidebarOpen, setSidebarOpen }: Props): React.ReactElement => {
  const { t } = useTranslation('sidebar');
  // const { hasPermission } = usePermission();
  const navItems = useMemo(() => {
    return [
      {
        id: 'root',
        name: 'vala',
        subName: 'matur',
        toggle: false,
        show: () => true,
        items: [
          {
            id: 'summary',
            name: t('summary'),
            to: '/',
            icon: faPencilAlt,
            show: () => true,
          },
          /*          {
            id: 'parent',
            name: t('userInfo'),
            to: '/minar-upplysingar',
            icon: faUser,
            show: () => false,
          }, */
        ],
      },
    ];
  }, [t]);

  return (
    <div
      className={classNames('sidebar-wrapper', {
        toggled: sidebarOpen,
      })}
    >
      <ul
        className={classNames('navbar-nav sidebar accordion', {
          toggled: sidebarOpen,
        })}
      >
        {navItems
          .filter((i) => i.show())
          .map((navItem) => (
            <div key={navItem.id} style={{ paddingTop: '20px' }}>
              <div className="list-wrapper">
                {navItem.items.map((item) => (
                  <li key={item.id} className={classNames('nav-item')}>
                    <NavLink exact to={item.to} className="nav-link" activeClassName="active">
                      {item.icon && <FontAwesomeIcon v-if="icon" className="nav-link-icon" fixedWidth icon={item.icon} />} <span>{item.name}</span>
                    </NavLink>
                  </li>
                ))}
              </div>
            </div>
          ))}
        <div className="toggle-button text-center d-none d-md-inline">
          <button type="button" className="rounded-circle border-0 sidebarToggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            <FontAwesomeIcon className="sidebarToggleIcon" icon={sidebarOpen ? faAngleRight : faAngleLeft} />
          </button>
        </div>
      </ul>
    </div>
  );
};

export default Sidebar;
